<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">phone</v-icon>
			<v-toolbar-title>Dane teleadresowe</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon color="white" class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Telefon</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="phoneNumber"
						data-vv-as="Telefon"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.phoneNumber')"
						v-model="data.phoneNumber"
						v-validate="{required: true, regex: /^[0-9 +-]*$/}"
						data-vv-validate-on="none"
						data-vv-scope="addressDataScope"
						aria-label="label for phone number">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Ulica</v-subheader>
				</v-flex>
				<v-flex xs7>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="street"
						data-vv-as="Ulica"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.street')"
						v-model="data.street"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for street">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Budynek</v-subheader>
				</v-flex>
				<v-flex xs2>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="building"
						data-vv-as="Budynek"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.building')"
						v-model="data.building"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for building">
					</v-text-field>
				</v-flex>
				<v-flex xs2>
					<v-subheader style="padding-left: 40%">Lokal</v-subheader>
				</v-flex>
				<v-flex xs3>
					<v-text-field
						browser-autocomplete="off"
						:readonly="readOnlyMode"
						v-model="data.apartment"
						aria-label="label for apartment">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs1>
					<v-subheader>Kod pocztowy</v-subheader>
				</v-flex>
				<v-flex xs2>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="postalCode"
						data-vv-as="Kod pocztowy"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.postalCode')"
						v-model="data.postalCode"
						v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
						return-masked-value
						:mask="'##-###'"
						data-vv-validate-on="none"
						data-vv-scope="addressDataScope"
						aria-label="label for postal code">
					</v-text-field>
				</v-flex>
				<v-flex xs2>
					<v-subheader style="padding-left: 40%">Miejscowość</v-subheader>
				</v-flex>
				<v-flex xs3>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="city"
						data-vv-as="Miejscowość"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('addressDataScope.city')"
						v-model="data.city"
						v-validate="'required'"
						data-vv-scope="addressDataScope"
						aria-label="label for city">
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "AddressProfileDataView",

		data () {
			return {
				readOnlyMode: true,

				data: {}
			};
		},

		watch: {
			addressData: function () {
				this.data = this.addressData;
			},

			readOnlyMode: function (value) {
				if (value) {
					this.$validator.validateAll("addressDataScope").then(result => {
						if (result) {
							this.$emit("edition-status", !value);
						} else {
							this.readOnlyMode = !this.readOnlyMode;
						}
					});
				} else {
					this.$emit("edition-status", !value);
				}
			}
		},

		computed: {
			icon () {
				return this.readOnlyMode ? 'edit' : 'save';
			},

			buttonLabel () {
				return this.readOnlyMode ? 'Edytuj' : 'Skończ edycję';
			}
		},

		props: {
			addressData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>